import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

export interface QueryBuilderInnerLabelProps {
  children?: ReactNode;
}

export function QueryBuilderInnerLabel(props: QueryBuilderInnerLabelProps): JSX.Element {
  return (
    <Typography
      sx={{
        display:"inline-block",
        m:0, p:0, pl:0.25, pr:0.25,
        verticalAlign: "middle",
        opacity: 0.9,
        fontWeight:'thin',
      }}>
      {props.children}
    </Typography>
  );
}
